import { api } from "@/services/api"
import type { UpdateStudySessionParams } from "@/services/api/odin/activities/lessons/update-study-session"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export default function useUpdateStudySession() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ["update-study-session"],
    mutationFn: (payload: UpdateStudySessionParams) =>
      api.odin.activities.lessons.updateStudySession(payload).then((resp) => resp.data.description),
    onSettled() {
      queryClient.invalidateQueries({
        queryKey: ["planner-get-weekly-objectives", "study-get-activities"],
      })
    },
  })
}
